import React from "react";
import { TextField, MenuItem, ListSubheader } from "@mui/material";
import { PAYLOAD_FIELD_TYPE_OPTIONS } from "../../utils/fieldTypeRegistry";

const TYPE_GROUPS = [
    { label: "Général", values: ["string", "integer", "number", "boolean"] },
    { label: "Dates & heures", values: ["date", "datetime", "time"] },
    { label: "Contact & identifiants", values: ["email", "phone", "uri", "uuid", "ipv4"] },
    { label: "Métier", values: ["currency", "percent"] },
    { label: "Structures", values: ["array", "object"] },
];

const PayloadFieldTypeSelect = ({ value, onChange, sx, width = 190 }) => {
    const optionByValue = new Map(PAYLOAD_FIELD_TYPE_OPTIONS.map((o) => [o.value, o]));
    const groupedValues = new Set(TYPE_GROUPS.flatMap((g) => g.values));
    const ungrouped = PAYLOAD_FIELD_TYPE_OPTIONS.filter((o) => !groupedValues.has(o.value));

    return (
        <TextField
            size="small"
            select
            label="Type"
            value={value || "string"}
            onChange={onChange}
            sx={{ width, ...sx }}
        >
            {TYPE_GROUPS.map((group) => [
                <ListSubheader key={`h-${group.label}`} sx={{ fontSize: 11, fontWeight: 700, lineHeight: "28px" }}>
                    {group.label}
                </ListSubheader>,
                ...group.values
                    .map((v) => optionByValue.get(v))
                    .filter(Boolean)
                    .map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    )),
            ])}
            {ungrouped.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
            ))}
        </TextField>
    );
};

export default PayloadFieldTypeSelect;
